<!-- fake heading for screen readers page change simulation -->
<span id="page-fake-title" *ngIf="title$ | async as title" class="is-vishidden" tabindex="-1">{{ title }}</span>
<div [class.menu-open]="isNavigationMenuOpen$ | async" [class]="contentWrapperNavigatedClass$ | async" #contentWrapper>
  <router-outlet></router-outlet>
</div>
<fin-client-only [componentType]="LOGIN_IFRAME_COMPONENT_TYPE" class="is-vishidden"></fin-client-only>
